/** @format */
import { Component, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';
import { ComponentDowngradeMappings, DowngradedComponent, EnvironmentService, StaticMembers } from 'sis-common';

@StaticMembers<DowngradedComponent>()
@Component({
    selector: 'sis-feedback-notification',
    templateUrl: './feedback-notification.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class FeedbackNotificationComponent {
    static readonly downgrade: ComponentDowngradeMappings = {
        moduleName: 'sisComponents.feedback.notification',
        directiveName: 'sisFeedbackNotification',
    };

    constructor(
        private readonly environmentService: EnvironmentService,
        private readonly stateService: StateService,
    ) {}

    frontendName = this.environmentService.frontendName.toLowerCase();
    feedbackState = `${this.frontendName}.logged-in.feedback`;

    goToFeedback() {
        this.stateService.go(this.feedbackState);
    }
}
